export default "__VITE_ASSET__Ct2xTzqk__"